import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AllCommunityModule, provideGlobalGridOptions, ValidationModule } from 'ag-grid-community';
import {
  CellSelectionModule,
  ContextMenuModule,
  LicenseManager,
  MasterDetailModule,
  ModuleRegistry,
  MultiFilterModule,
  RowGroupingModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
  TreeDataModule,
} from 'ag-grid-enterprise';

function initAgGrid(): void {
  ModuleRegistry.registerModules([
    // Community
    AllCommunityModule,
    // Enterprise
    CellSelectionModule,
    ContextMenuModule,
    MasterDetailModule,
    MultiFilterModule,
    RowGroupingModule,
    ServerSideRowModelApiModule,
    ServerSideRowModelModule,
    SetFilterModule,
    TreeDataModule,
    ...(environment.production ? [] : [ValidationModule]),
  ]);

  LicenseManager.setLicenseKey(environment.agGridLicenseKey);

  provideGlobalGridOptions(
    {
      icons: {
        sortAscending:
          '<svg class="ag-grid-sort-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 21V4.707L9.354 7.354l-.707-.707L12.5 2.793l3.854 3.854-.707.707L13 4.707V21z"/></svg>',
        sortDescending:
          '<svg class="ag-grid-sort-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M9.354 16.646L12 19.293V3h1v16.293l2.646-2.646.707.707-3.853 3.853-3.854-3.853z"/></svg>',
        sortUnSort:
          '<svg class="ag-grid-sort-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M6 21V4.707L3.354 7.354l-.707-.707L6.5 2.793l3.854 3.854-.707.707L7 4.707V21zM17 3v16.293l-2.646-2.646-.707.707 3.853 3.853 3.854-3.854-.707-.707L18 19.293V3z"/></svg>',
        rowDrag:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M8 2.5A1.5 1.5 0 1 0 9.5 4 1.5 1.5 0 0 0 8 2.5zm8 0A1.5 1.5 0 1 0 17.5 4 1.5 1.5 0 0 0 16 2.5zm-8 8A1.5 1.5 0 1 0 9.5 12 1.5 1.5 0 0 0 8 10.5zm8 0a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5zm-8 8A1.5 1.5 0 1 0 9.5 20 1.5 1.5 0 0 0 8 18.5zm8 0a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z"/></svg>',
      },
      defaultColDef: {
        cellClassRules: {
          'cell-editable-custom': (params) => {
            const isEditable = params.colDef.editable;

            return typeof isEditable === 'function' ? isEditable(params) : !!isEditable;
          },
        },
      },
    },
    'deep',
  );
}

export function provideAgGrid(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(initAgGrid)]);
}
